// Generated by scripts/update-seeq-icons.js from src/svg/seeq/more.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcMore = {
  prefix: 'fak',
  iconName: 'more' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f944',
    'M655.4 512c0 79.2-64.2 143.4-143.4 143.4s-143.4-64.2-143.4-143.4c0-79.2 64.2-143.4 143.4-143.4s143.4 64.2 143.4 143.4zM655.4 880.6c0 79.2-64.2 143.4-143.4 143.4s-143.4-64.2-143.4-143.4c0-79.2 64.2-143.4 143.4-143.3s143.4 64.2 143.4 143.3zM655.4 143.4c0 79.2-64.2 143.4-143.4 143.3s-143.4-64.2-143.4-143.3c0-79.2 64.2-143.4 143.4-143.4s143.4 64.2 143.4 143.4z',
  ],
} satisfies IconDefinition;
